import { computed } from 'nanostores'

import { AddonGroup } from '@/models/addon-group'
import { $loggedInSettings } from '@/stores/logged-in-settings/stores'

import { $addons } from './stores'

export const $loggedInAddonGroups = computed(
  [$addons, $loggedInSettings],
  (popsAddons, loggedInSettings) => {
    return (
      loggedInSettings?.addons?.addonGroups?.map((groupConfig) => {
        return new AddonGroup(groupConfig, popsAddons)
      }) || []
    )
  },
)

export const $calendarAddonGroups = $loggedInAddonGroups
export const $accountSettingsAddonGroups = $loggedInAddonGroups

export const $loggedInAddons = computed($loggedInAddonGroups, (groups) => {
  return groups.flatMap((group) => group.addons)
})

export const $addonSkus = computed($addons, (addons) => {
  return addons.map((addon) => addon.shopify_sku)
})
